import { createFileRoute } from "@tanstack/react-router";
import { AddServicePage } from "@/components/inventory/AddServicePage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/inventory_/new_/service")({
  beforeLoad: () => {
    requireAuth();
  },
  component: AddServicePage,
});
